const neededProps = ["city", "state", "street", "zip_code"];

export default {
  checkForAddressInputErrors(errors) {
    if (!errors) {
      return false;
    }
    const errorFields = errors.map((item) => item.$property);
    const addressFields = ["street", "city", "state", "zip_code"];
    return errorFields.some((field) => addressFields.includes(field));
  },
  validateAddress(selectedAddress) {
    const missingProps = [];
    neededProps.forEach((prop) => {
      if (!selectedAddress[prop]) {
        missingProps.push(prop);
      }
    });
    return missingProps;
  },
  formatAddress(apiAddress) {
    const route =
      apiAddress.street_number && apiAddress.route
        ? `${apiAddress.street_number} ${apiAddress.route}`
        : null;

    return {
      street: route,
      state: apiAddress.administrative_area_level_1,
      latitude: apiAddress.latitude,
      longitude: apiAddress.longitude,
      city: apiAddress.locality,
      zip_code: apiAddress.postal_code,
    };
  },
};
